import BaseComponent from '../../../js/base-component';
import { Loader } from "@googlemaps/js-api-loader";

class StoreList extends BaseComponent {

    constructor(element) {
        super(element);

        const apiKey = "AIzaSyBQ_aCybg5OOLgDeSGbDDptzH2hQ_vTfgA"; // Seeger DEV -- AIzaSyDIpv2RliUBlrAy3lCXmn0aKsR70RPKAac
        this.consent = false;
        this.activeItems = [];
        this.entries = this.element.querySelectorAll('.u-address__item');
        this.openingHours = Array.from(this.element.querySelectorAll('.u-address__opening-hours')) || [];

        if (this.entries.length) {
            this.entries.forEach((ele) => {
                ele.querySelector('.u-address__head').addEventListener('click', (evt) => {
                    evt.preventDefault();

                    this.toggleAddress(evt);
                });

                // load map in opened state
                if ( ele.classList.contains('is--open') ) {
                    this.openAddress(ele.childNodes[0]);
                }
            });
        }

        if (this.openingHours.length) {
            this.openingHours.forEach((ele) => {
                this.presetOpeningHours(ele);
            });
        }

        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.preferences) {
                this.consent = Cookiebot.consent.preferences;

                // load Maps, apikey & version
                this.loader = new Loader({
                    apiKey: apiKey,
                    version: "weekly",
                });

                this.activeItems = this.element.querySelectorAll('.u-address__item.is--active') || [];

                if (this.activeItems.length) {
                    this.activeItems.forEach((ele) => {
                        this.loadMap(ele);
                    });
                }
            }
        }, false);
    }

    openAddress(ele) {
        // Create our event (with options)
        let evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        // If cancelled, don't dispatch our event
        let canceled = !ele.dispatchEvent(evt);
    };

    /**
     * toggle address block
     * @param evt
     */
    toggleAddress(evt) {
        let rootEle = evt.target.closest('.u-address__item');

        if ( rootEle.classList.contains('is--active') ) {
            rootEle.classList.remove('is--active');
        } else {
            rootEle.classList.add('is--active');
        }

        if (this.consent) {
            this.loadMap(rootEle);
        }
    }

    /**
     * load google maps map
     * @param item
     */
    loadMap(item) {
        const mapContainer = document.getElementById('mapid-' + item.dataset.id);
        const lat = Number(item.dataset.latitude);
        const lng = Number(item.dataset.longitude);

        if (!item.classList.contains('map-loaded')) {
            mapContainer.classList.remove('not-loaded');

            this.loader.load().then(() => {
                let map = new google.maps.Map(mapContainer, {
                    center: { lat: lat, lng: lng },
                    fullscreenControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: false,
                    zoom: 14,
                });

                new google.maps.Marker({
                    position: { lat: lat, lng: lng },
                    map
                });
            });

            item.classList.add('map-loaded');
        }
    }

    /**
     * preset the date dropdown with day of week
     */
    presetOpeningHours(ele) {
        const date = new Date();
        let dayOfWeek = date.getDay();
        const days = Array.from(ele.childNodes).map(x => x.value);

        // console.log(dayOfWeek);

        if ( days.find(element => element == dayOfWeek) ) {
            ele.value = dayOfWeek;
        } else {
            for (let index = 0; index < days.length; index++) {
                const element = days[index];

                // today is not in days, set next open day
                if ( element > dayOfWeek ) {
                    ele.value = element;
                    return;
                }

                // today is bigger than last entry in days, set first entry in days
                if ( dayOfWeek > element && index == days.length) {
                    ele.value = days[0];
                    return;
                }
            }
        }
    }
}

export default {
  name: 'StoreList',
  definition: StoreList
};
